import {enableProdMode, provideZoneChangeDetection} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import 'hammerjs';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import {Amplify} from 'aws-amplify';
import {authConfig} from './app/core/auth/auth.config';

if (environment.production) {
  enableProdMode();
}

delete Hammer.defaults.cssProps.userSelect;

Amplify.configure({Auth: authConfig});

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
